// tslint:disable file-name-casing
import 'custom-event-polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { Provider as ReduxQueryProvider } from 'redux-query-react';
import configureStore from './helpers/reduxStore';
import LocaleRouter from './routers/LocaleRouter';
import { PublicClientApplication } from '@azure/msal-browser';
import { msalConfig } from './authConfig';
import { MsalProvider } from '@azure/msal-react';
import { ThemeProvider } from 'styled-components';
import { defaultTheme } from './common/styles/theme/default';

const msalInstance = new PublicClientApplication(msalConfig);
const rootEl = document.getElementById('root');
export const store = configureStore();

if (document.documentElement) {
  document.documentElement.classList.remove('is-loading');
}

ReactDOM.render(
  (
      <MsalProvider instance={msalInstance}>
        <Provider store={store}>
          <ReduxQueryProvider queriesSelector={(state) => state.queries}>
            <ThemeProvider theme={defaultTheme}>
              <BrowserRouter>
                <LocaleRouter />
              </BrowserRouter>
            </ThemeProvider>
          </ReduxQueryProvider>
        </Provider>
      </MsalProvider>
  ),
  rootEl
);
